import { createContext } from 'react';

const initialValue: { companyId: string | null } = { companyId: null };

export const Context = createContext(initialValue);

export default Context.Provider;
